// @ts-strict-ignore
import JSURL from 'jsurl';

import {ReportName} from 'common/report/constants';
import {ReportHeader, ReportHeaderJsxProps} from 'common/report/report-manager/report-header';
import {SearchDisplayContext} from 'common/report/util/search/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {FlowsBookmark} from 'common/report/flows/models/types';
import {FlowsResponse} from 'common/report/funnels/models/api-types';
import {FlowsReport} from 'common/report/flows/models/report';

export class FlowsReportHeader extends ReportHeader<FlowsBookmark, FlowsResponse> {
  displayContext = SearchDisplayContext.Flows;
  reportType = ReportName.Flows;
  customAlertsEnabled = false;
  csvExportEnabled = false;

  getInvalidParamsMessage(): string {
    if (!this.bookmark.params.steps.filter((step) => step?.event !== null).length) {
      return `Please select an event to save your flows report`;
    }

    return null;
  }

  getStandaloneHash(titleOverride?: string) {
    const report = FlowsReport.fromBookmarkParams(this.bookmark.params);
    if (titleOverride) {
      report.name = titleOverride;
    }

    return JSURL.stringify(report.toUrlData());
  }
}

export const FlowsReportHeaderEl = defineAndMakeJsxFactory<ReportHeaderJsxProps>(
  `flows-report-header`,
  FlowsReportHeader,
);
export const FlowsReportHeaderReact = panel2react<ReportHeaderJsxProps>(`flows-report-header`, FlowsReportHeader);
